
// Blur Image Loading with solid color: rgb(225, 225, 225), same as the CatSkeletonLoader background
// Ref: https://nextjs.org/docs/app/api-reference/components/image#blurdataurl
export const BLUR_IMAGE_PLACEHOLDER =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN8+B8AAscB4jINlWEAAAAASUVORK5CYII=';
